import MUT from '../../constants/vuexMutations'
import ACT from '../../constants/vuexActions'
import configQueries from '../../graphql/config'
import apolloClient from '../../apolloClient'

const moduleConfig = {
  namespaced: false,
  state () {
    return {
      rollsCount: null
    }
  },
  actions: {
    [ACT.GET_CONFIG_ROLLS_COUNT] ({commit}) {
      apolloClient.query({
        query: configQueries.getConfigRecord,
        variables: {
          param: 'rolls_count'
        }
      }).then(res => {
        commit(MUT.SET_CONFIG_ROLLS_COUNT, res.data.allConfigs.nodes[0].value)
      })
    }
  },
  mutations: {
    [MUT.SET_CONFIG_ROLLS_COUNT] (state, payload) {
      state.rollsCount = payload
    }
  },
  getters: {
    rollsCount (state) {
      return state.rollsCount
    }
  }
}

export default moduleConfig



// WEBPACK FOOTER //
// ./src/vuex/reusablemodules/config.js